import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "forgot-shell" }
const _hoisted_2 = { class: "forgot-card" }
const _hoisted_3 = {
  key: 0,
  class: "success-state"
}
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = { class: "input-field" }
const _hoisted_6 = {
  key: 0,
  class: "error-text"
}
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-link",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
        ], -1),
        _createTextVNode(" Voltar ", -1)
      ]))]),
      _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "forgot-title" }, "Esqueci minha senha", -1)),
      (_ctx.sent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createStaticVNode("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#1f8a45\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-caa51aa4><path d=\"M22 11.08V12a10 10 0 1 1-5.93-9.14\" data-v-caa51aa4></path><polyline points=\"22 4 12 14.01 9 11.01\" data-v-caa51aa4></polyline></svg><p class=\"success-text\" data-v-caa51aa4> Se essa conta existir e tiver um e-mail cadastrado, você receberá um link de redefinição em breve.<br data-v-caa51aa4><span class=\"success-sub\" data-v-caa51aa4>Verifique também sua caixa de spam.</span></p>", 2)),
            _createElementVNode("button", {
              class: "btn-primary",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, "Voltar para o login")
          ]))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            class: "forgot-form",
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "forgot-desc" }, " Informe o identificador da obra e seu usuário. Se houver um e-mail cadastrado, enviaremos um link de redefinição. ", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "fg-system" }, "Obra (identificador)", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "fg-system",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.systemUsername) = $event)),
                type: "text",
                placeholder: "Ex.: minhaobra",
                autocomplete: "off"
              }, null, 512), [
                [_vModelText, _ctx.systemUsername]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { for: "fg-username" }, "Seu usuário", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "fg-username",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.username) = $event)),
                type: "text",
                placeholder: "Ex.: joao.silva",
                autocomplete: "username"
              }, null, 512), [
                [_vModelText, _ctx.username]
              ])
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-primary",
              type: "submit",
              disabled: _ctx.loading
            }, _toDisplayString(_ctx.loading ? 'Enviando...' : 'Enviar link de redefinição'), 9, _hoisted_7)
          ], 32))
    ])
  ]))
}